export default "__VITE_ASSET__b267c514__"